import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { ProfileQuery } from 'types/queries';

type Props = {
  rules?: ProfileQuery['profile']['rules'];
};

const Rules = ({ rules }: Props):JSX.Element => (
  <>
    <Grid size={12}>
      <Box marginBottom={0.5}>
        <Typography fontWeight={600} color="textSecondary">
          Regras
        </Typography>
      </Box>
    </Grid>
    {rules?.map((rule) => (
      <Grid key={rule.id} size={12}>
        <Box display="flex">
          <Box width="33%">
            <Typography fontWeight={400} fontSize="0.75rem" color="textSecondary">
              Tipo
            </Typography>
            <Typography fontWeight={400} variant="body2">
              {rule.kindI18n}
            </Typography>
          </Box>
          <Box width="33%">
            <Typography fontWeight={400} fontSize="0.75rem" color="textSecondary">
              Forma de Pagamento
            </Typography>
            <Typography fontWeight={400} variant="body2">
              {rule.paymentKindI18n}
            </Typography>
          </Box>
          <Box width="33%">
            <Typography fontWeight={400} fontSize="0.75rem" color="textSecondary">
              Valor
            </Typography>
            <Typography fontWeight={400} variant="body2">
              {rule.paymentKind === 'fixed' ? rule.fixedValue.format : rule.percentValue}
            </Typography>
          </Box>
        </Box>
      </Grid>
    ))}
  </>
);

export default Rules;
